"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementStyleModifier = void 0;
const getElementById = (id) => document.getElementById(id);
const overrideStyle = (elementId, styleOverride) => {
    const element = getElementById(elementId);
    if (element && Object.keys(styleOverride).length) {
        const newStyle = Object.assign({}, element.style, styleOverride);
        for (const property in newStyle) {
            const propertyIsNaN = isNaN(Number(property));
            const hasOwnProperty = Object.prototype.hasOwnProperty.call(newStyle, property);
            if (hasOwnProperty && propertyIsNaN) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                element.style[property] = newStyle[property];
            }
        }
    }
};
/**
 * Uma função que modifica o CSS de um elemento HTML com base nos parâmetros fornecidos.
 *
 * @param {string | string[]} elementId - A ID ou IDs dos elementos HTML a serem modificados.
 * @param {boolean} watchElement - Uma flag para habilitar ou desabilitar a observação do elemento.
 * @param {Record<string, string>} styleOverride - Estilos CSS para substituir no elemento.
 * @return {void}
 */
const elementStyleModifier = ({ elementId, styleOverride, watchElement, }) => {
    const handleStyleOverride = () => {
        if (Array.isArray(elementId)) {
            elementId.forEach((id) => overrideStyle(id, styleOverride));
        }
        else {
            overrideStyle(elementId, styleOverride);
        }
    };
    const observer = new MutationObserver(handleStyleOverride);
    handleStyleOverride();
    // Listen for changes in the DOM and override the element's style if it appears later
    observer.observe(document.documentElement, { childList: true, subtree: true });
    if (!watchElement) {
        observer.disconnect();
    }
};
exports.elementStyleModifier = elementStyleModifier;
